import React, { Fragment, useState } from "react";
import { createRoot } from "react-dom/client";
import { Combobox } from '@headlessui/react'

function SearchEpisode({ handleChange = null, onlyPublished = true, value = "", podcastId }) {

    const [defaultValue, setDefaultValue] = useState(value);
    const [episodes, setEpisodes] = useState([]);

    function fetchEpisodes(episode) {

        const params = {
            search: episode,
        }
        if (onlyPublished) params.published = true;

        if(episode !== "") {
            axios.get(`/search/podcasts/${podcastId}/episodes`, {
                params
            })
            .then(function (response) {
                setEpisodes(response.data)
            })
            .catch(function (error) {
                console.error(error);
            });
        } else {
            setEpisodes([]);
        }
    }

    return (
    <Combobox 
        value={defaultValue} 
        onChange={(episode) => {
            setDefaultValue(episode.post_title)
            if (handleChange) handleChange(episode);
        }} 
        as="div" 
        className="relative">
        <Combobox.Input
            maxLength="100"
            className="input bg-gray-100" 
            onChange={(e) => {
                fetchEpisodes(e.target.value)
            }}
        />
        <Combobox.Options className="absolute top-12 bg-white z-20 w-full rounded-b-md shadow-md text-gray-700 overflow-hidden overflow-y-auto max-h-80">
            {episodes.map((episode) => (
                <Combobox.Option key={episode.id} value={episode} className={(state) => `p-4 py-2 hover:bg-purple-100 w-full text-left block hover:cursor-pointer ${state.active ? 'bg-purple-100' : ''}`}>
                    <p
                        key={episode.id}
                        className="line-clamp-1"
                    >
                        {episode.post_title}
                    </p>
                </Combobox.Option>
            ))}
        </Combobox.Options>
    </Combobox>
    );
}

const initSearchEpisode = function(selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach(element => {
        const root = createRoot(element);
        const value = element.dataset.value;
        const podcastId = element.dataset.podcastid;
        root.render(<SearchEpisode value={value} podcastId={podcastId} />);
    });
  }
};

export { SearchEpisode as default, initSearchEpisode };
